import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { DetailsRow } from "../../../../common/modal/details-rows/DetailsRow";

type TypeRowProps = {
    type: string;
};

export const TypeRow = ({ type }: TypeRowProps) => {
    const { translate } = useTranslate();

    return (
        <DetailsRow label={translate("activation.alerts.cards.display-ads.modal.type")}>
            <Text
                fontVariant="input2"
                color={colorsPalettes.carbon[500]}
                textTransform="capitalize"
            >
                {type}
            </Text>
        </DetailsRow>
    );
};
